import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import SessionValidation from "../context/SessionValidationContext";
import { fetchToken } from "../services/fetchTokenService";
import { getConsumerKey } from "../services/maerskApiTokenService";

export const PostWithRetry = () => {
  const { instance, accounts } = useMsal();
  const { setSessionExpired } = SessionValidation();
  const postWithRetry = async (
    url,
    data,
    retries = 3,
    delay = 1000
  ) => {
    try {
      // Keep MSAL session validation
      const tokenResponse = await fetchToken(instance, loginRequest, accounts);
      if (tokenResponse && tokenResponse.sessionExpired) {
        sessionStorage.clear();
        setSessionExpired(true);
      }

      // Use Maersk API token (client-credentials) for API gateway auth
      // const apiToken = await getApiToken();

      const config = {
        headers: {
          Authorization: `Bearer ${tokenResponse.idToken}`,
          "consumer-key": getConsumerKey(),
        },
      };

      // Don't set Content-Type for FormData, let axios handle it
      if (!(data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
      }

      const response = await axios.request({
        ...config,
        method: "post",
        url: url,
        data: data,
      });
      // Creation endpoints correctly return 201; accept any 2xx as success.
      if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        sessionStorage.clear();
        throw error;
      }

      if (retries === 0 || !(error.response && error.response.status === 401)) {
        console.error("error ", error)
        throw error;
      }

      await new Promise((res) => setTimeout(res, delay));
      return postWithRetry(url, data, retries - 1, delay * 2);
    }
  };

  return {
    postWithRetry,
  };
};
